import { PageContainer } from "src/components/organisms/contents";
import { ReactComponent as IconLeftArrow } from "../../styles/assets/svg/icon_LeftChevron.svg";
import { ReactComponent as IconRightArrow } from "../../styles/assets/svg/icon_RightChevron.svg";
import { ReactComponent as IconSparkle } from "../../styles/assets/svg/icon_sparkle.svg";
import { ReactComponent as IconRT01 } from "../../styles/assets/svg/icon_RT01.svg";
import { ReactComponent as IconRT02 } from "../../styles/assets/svg/icon_RT02.svg";
import { ReactComponent as IconRT03 } from "../../styles/assets/svg/icon_RT03.svg";
import { ReactComponent as IconRT04 } from "../../styles/assets/svg/icon_RT04.svg";
import { ReactComponent as IconRT05 } from "../../styles/assets/svg/icon_RT05.svg";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import coverImg from "../../styles/assets/img/report_cover_img.png";
import thumbsUp from "../../styles/assets/img/Thumbs_Up.png";
import { useUserRegister } from "src/common/hooks/useUserRegister";
import { ContentsBox } from "../diet/components/DietWritePage";
import styled from "styled-components";
import WeeklyBarChart from "../walk/components/WeeklyBarChart";
import { titleText } from "src/components/atoms/MainHeaderBox/MainConHeader";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { CircularGauge } from "./components/CircularGauge";
import isoWeek from "dayjs/plugin/isoWeek";
import { AIMessage, ReportMessage } from "./components/ReportMessage";
dayjs.extend(isoWeek);

export const ScrollContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none; /* IE, Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  margin-bottom: 16px;
`;

// 문자열을 해시값(숫자)으로 변환
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // 32bit 정수로 변환
  }
  return Math.abs(hash);
}

/* 날짜 기반 랜덤 seed 값 */
function seededRandom(seed: number) {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

function getRandomInt(
  userOid: string,
  date: string,
  index: number,
  min: number,
  max: number
) {
  const weekStart = dayjs(date).startOf("week").format("YYYY-MM-DD");
  const seed = hashString(`${userOid}-${weekStart}-${index}`);
  const rand = seededRandom(seed);
  return Math.floor(rand * (max - min + 1)) + min;
}

function getRandomSteps(userOid: string, date: string) {
  return [
    getRandomInt(userOid, date, 0, 60, 100),
    getRandomInt(userOid, date, 1, 60, 100),
    getRandomInt(userOid, date, 2, 60, 100),
  ];
}

const cateGory = ["식단", /* "운동",  */ "걷기", "복약"];
const categoryIcons = [IconRT01, IconRT05, IconRT04, IconRT03];
export const HealthReportPage = () => {
  const today = dayjs().format("YYYY.MM.DD");
  const firstDay = dayjs(today.replace(/\./g, "-"))
    .startOf("week")
    .format("YYYY.MM.DD");
  const lastDay = dayjs(today.replace(/\./g, "-"))
    .endOf("week")
    .format("YYYY.MM.DD");
  const { data: userInfo } = useUserRegister();

  const [weeklySteps, setWeeklySteps] = useState<number[]>([]); // 여기 값 바꿔주면 됨

  useEffect(() => {
    if (userInfo?.oid) {
      setWeeklySteps(
        getRandomSteps(userInfo.oid, firstDay.replace(/\./g, "-"))
      );
    }
  }, [userInfo, firstDay]);

  const [selectedFDate, setSelectedFDate] = useState<string>(firstDay); // 날짜 선택 상태
  const [selectedLDate, setSelectedLDate] = useState<string>(lastDay); // 날짜 선택 상태
  const [selectedActive, setSelectedActive] = useState<string>("식단"); // 카테고리
  const [idx, setIdx] = useState<number>(0); // 인덱스 저장

  const handlePrev = () => {
    const newDate = dayjs(selectedFDate.replace(/\./g, "-"))
      .subtract(1, "week")
      .format("YYYY.MM.DD");
    setSelectedFDate((prev) =>
      dayjs(prev.replace(/\./g, "-")).subtract(1, "week").format("YYYY.MM.DD")
    );
    setSelectedLDate((prev) =>
      dayjs(prev.replace(/\./g, "-")).subtract(1, "week").format("YYYY.MM.DD")
    );

    setWeeklySteps(getRandomSteps(userInfo?.oid!, newDate.replace(/\./g, "-")));
  };

  const handleNext = () => {
    const newDate = dayjs(selectedFDate.replace(/\./g, "-"))
      .add(1, "week")
      .format("YYYY.MM.DD");
    setSelectedFDate((prev) => {
      const nextFirst = dayjs(prev.replace(/\./g, "-")).add(1, "week");
      const nextLast = nextFirst.endOf("week");
      const maxLast = dayjs(today).endOf("week");

      if (nextLast.isAfter(maxLast)) {
        return prev; // 더 이상 못 넘어감
      }

      setSelectedLDate(nextLast.format("YYYY.MM.DD"));
      setWeeklySteps(
        getRandomSteps(userInfo?.oid!, newDate.replace(/\./g, "-"))
      );

      return nextFirst.format("YYYY.MM.DD");
    });
  };

  const totalScore = Math.floor(
    weeklySteps.reduce((sum, n) => sum + n, 0) / weeklySteps.length
  );
  // ✅ 지난 주 점수 계산
  const prevWeekDate = dayjs(selectedFDate.replace(/\./g, "-"))
    .subtract(1, "week")
    .format("YYYY-MM-DD");

  const prevWeekSteps = userInfo?.oid
    ? getRandomSteps(userInfo.oid, prevWeekDate)
    : [];

  const prevWeekScore =
    prevWeekSteps.length > 0
      ? Math.floor(
          prevWeekSteps.reduce((sum, n) => sum + n, 0) / prevWeekSteps.length
        )
      : 0;
  const diff = totalScore - prevWeekScore;
  const percentile = Math.max(1, Math.min(100, 100 - totalScore));

  const isUp = diff >= 0;

  return (
    <PageContainer isNavBar={true} active="report">
      <>
        {/* 헤더 */}
        <SubConHeader title="AI 건강 리포트" setBackIcon={true} />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            // gap: 24,
            paddingBottom: "90px",
          }}
        >
          {/* 날짜 선택 */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: 48,
              zIndex: 1,
              // padding: 8,
              // background: "var(--white, white)",
              // boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
              // borderRadius: 999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 8px",
              }}
            >
              <IconLeftArrow
                style={{ cursor: "pointer" }}
                onClick={handlePrev}
              />
              <div style={{ ...titleText, fontWeight: 700, cursor: "pointer" }}>
                {`${dayjs(selectedFDate.replace(/\./g, "-")).format(
                  "MM.DD"
                )} ~ ${dayjs(selectedLDate.replace(/\./g, "-")).format(
                  "MM.DD"
                )}`}
              </div>
              <IconRightArrow
                style={{ cursor: "pointer" }}
                onClick={handleNext}
              />
            </div>
            {/* 모달 */}
            {/* {openCalendar && (
              <ModalDatePicker
                data={selectedDate}
                title="날짜"
                onClose={() => setOpenCalendar(false)}
                onConfirm={(year, month, day) => {
                  setSelectedDate(formatDate(year, month, day));
                  setOpenCalendar(false);
                }}
              />
            )} */}
          </div>

          {/* 커버 이미지 */}
          <div
            style={{
              position: "relative",
              width: "calc(100% + 32px)",
              height: "360px",
            }}
          >
            <img
              src={coverImg}
              alt="WeekReportCover"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <div
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  color: "#723300",
                  fontSize: 24,
                  fontWeight: "700",
                  lineHeight: "32px",
                }}
              >
                {userInfo?.userName} 님의
                <br />
                이번주 건강리포트
              </div>
              <div
                style={{
                  color: "#CC6100",
                  fontSize: 16,
                  fontWeight: "500",
                  lineHeight: "24px",
                }}
              >{`${selectedFDate} ~ ${selectedLDate}`}</div>
            </div>
          </div>
          {/* 주간 건강 종합 점수 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 16,
              width: "100%",
              marginTop: 32,
              padding: "0 8px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 8,
                color: "var(--neutral-800, #262626)",
                fontSize: 20,
                fontWeight: "700",
                lineHeight: "28px",
              }}
            >
              <div>주간 건강 종합 점수</div>
              <div
                style={{
                  width: "36px",
                  padding: "2px 4px",
                  background: totalScore > 70 ? "#77DA63" : "#FFD000",
                  borderRadius: 8,
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 10,
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color: "white",
                    fontSize: 13,
                    fontWeight: "500",
                    lineHeight: "20px",
                  }}
                >
                  {totalScore > 70 ? "양호" : "주의"}
                </div>
              </div>
            </div>
            <ContentsBox>
              {/* 차트 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <img src={healthChart} alt={"차트 리포트"} /> */}
                {weeklySteps.length > 0 && <CircularGauge score={totalScore} />}

                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    position: "absolute",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      color: "var(--neutral-700, #404040)",
                      fontSize: 32,
                      fontWeight: "600",
                      lineHeight: "44px",
                    }}
                  >
                    {isNaN(totalScore) ? "-" : totalScore}
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      color: "var(--neutral-700, #404040)",
                      fontSize: 14,
                      fontWeight: "500",
                      lineHeight: "20px",
                    }}
                  >
                    점
                  </div>
                </div>
              </div>
              {/* 상승폭 */}
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    padding: "6px 10px",
                    background: "var(--neutral-100, #F5F5F5)",
                    borderRadius: 6,
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 4,
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      color: "var(--neutral-700, #404040)",
                      fontSize: 14,
                      fontWeight: "500",
                      lineHeight: "20px",
                    }}
                  >
                    지난주 대비
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      color: "#F57C00",
                      fontSize: 14,
                      fontWeight: "700",
                      lineHeight: "20px",
                    }}
                  >
                    {Math.abs(diff)}점
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      color: "var(--neutral-700, #404040)",
                      fontSize: 14,
                      fontWeight: "500",
                      lineHeight: "20px",
                    }}
                  >
                    {isUp ? "상승" : "하락"}
                  </div>
                  <div style={{ width: 16, height: 16, position: "relative" }}>
                    <img
                      style={{
                        width: 16,
                        height: 16,
                        left: 0,
                        top: 0,
                        position: "absolute",
                      }}
                      src={thumbsUp}
                      alt="thumbsUp"
                    />
                  </div>
                </div>
                {/* 분석 */}
                <div>
                  <p
                    style={{
                      color: "var(--neutral-700, #404040)",
                      fontSize: 16,
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    이번 주 건강 점수는{" "}
                    <span
                      style={{
                        color: "var(--neutral-700, #404040)",
                        fontSize: 16,
                        fontWeight: "700",
                        lineHeight: "24px",
                      }}
                    >
                      {isNaN(totalScore) ? "-" : totalScore}점
                    </span>
                  </p>

                  <p
                    style={{
                      color: "var(--neutral-700, #404040)",
                      fontSize: 16,
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    전체 사용자 중{" "}
                    <span
                      style={{
                        color: "var(--neutral-700, #404040)",
                        fontSize: 16,
                        fontWeight: "700",
                        lineHeight: "24px",
                      }}
                    >
                      상위 {Math.floor(percentile)}%
                    </span>
                    <span
                      style={{
                        color: "var(--neutral-700, #404040)",
                        fontSize: 16,
                        fontWeight: "500",
                        lineHeight: "24px",
                      }}
                    >
                      예요 👏
                    </span>
                  </p>
                </div>
              </div>
            </ContentsBox>
          </div>

          {/* 루틴 실천 분석 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 16,
              width: "100%",
              marginTop: 24,
              padding: "0 8px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 8,
                color: "var(--neutral-800, #262626)",
                fontSize: 20,
                fontWeight: "700",
                lineHeight: "28px",
              }}
            >
              <div>루틴 실천 분석</div>
            </div>
            <ContentsBox>
              {/* 차트 */}
              <div
                style={{
                  width: "100%",
                  maxWidth: "45rem",
                }}
              >
                {weeklySteps.length > 0 && (
                  <WeeklyBarChart
                    data={weeklySteps}
                    maxHint={100}
                    height={255}
                    barWidth={45}
                    gap={14}
                  />
                )}
              </div>
              {/* 카테고리 */}
              <ScrollContainer>
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 7,
                    flexWrap: "nowrap",
                    width: "max-content",
                  }}
                >
                  {cateGory.map((item, idx) => {
                    const IconComponent = categoryIcons[idx];
                    const active = selectedActive === item;
                    return (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: 88,
                          height: 38,
                          padding: "4px 12px",
                          background: active ? "#404040" : "#fafafa",
                          borderRadius: 50,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedActive(item);
                          setIdx(idx);
                        }}
                      >
                        <div style={{ display: "flex", gap: 8 }}>
                          <IconComponent />
                          <div
                            style={{
                              fontSize: 16,
                              fontWeight: "500",
                              lineHeight: "24px",
                              color: active ? "#fafafa" : "#a3a3a3",
                            }}
                          >
                            {item}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </ScrollContainer>

              <div
                style={{
                  width: "100%",
                  height: "100%",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 12,
                  display: "flex",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 4,
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      color: "var(--neutral-700, #404040)",
                      fontSize: 18,
                      fontWeight: "700",
                      lineHeight: "28px",
                    }}
                  >
                    {selectedActive}
                  </div>
                  <div
                    style={{
                      color: "var(--neutral-200, #E5E5E5)",
                      fontSize: 16,
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    |
                  </div>
                  <div
                    style={{
                      color: "var(--neutral-700, #404040)",
                      fontSize: 16,
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    실천률: {weeklySteps[idx]}%
                  </div>
                  <div
                    style={{
                      width: 36,
                      padding: "2px 4px",
                      background: weeklySteps[idx] > 80 ? "#77DA63" : "#FFD000",
                      borderRadius: 8,
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 10,
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        color: "white",
                        fontSize: 13,
                        fontWeight: "500",
                        lineHeight: "20px",
                      }}
                    >
                      {weeklySteps[idx] > 80 ? "양호" : "주의"}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 4,
                    display: "flex",
                  }}
                >
                  <IconSparkle />
                  <div
                    style={{
                      color: "#F57C00",
                      fontSize: 16,
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    기록 요약
                  </div>
                </div>
                <ul
                  style={{
                    listStyleType: "disc",
                    paddingLeft: 20,
                  }}
                >
                  <ReportMessage type={selectedActive} />
                </ul>
                <div
                  style={{
                    // width: 296,
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 4,
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 4,
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        color: "white",
                        fontSize: 14,
                        fontWeight: "500",
                        lineHeight: "20px",
                        width: "28px",
                        height: "16px",
                        background:
                          "linear-gradient(180deg, #FFA040 0%, #F57C00 100%)",
                        overflow: "hidden",
                        borderRadius: 50,
                      }}
                    >
                      AI
                    </div>
                    <div
                      style={{
                        color: "#F57C00",
                        fontSize: 16,
                        fontWeight: "500",
                        lineHeight: "24px",
                      }}
                    >
                      제안
                    </div>
                  </div>
                  <div
                    style={{
                      paddingLeft: 12,
                      borderLeft: "3px var(--neutral-200, #E5E5E5) solid",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 10,
                      display: "flex",
                    }}
                  >
                    <ul
                      style={{
                        listStyleType: "disc",
                        paddingLeft: 20,
                      }}
                    >
                      <AIMessage type={selectedActive} />
                    </ul>
                  </div>
                </div>
              </div>
            </ContentsBox>

            {/* 추천 루틴 제안 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 16,
                width: "100%",
                marginTop: 24,
                // padding: "0 8px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 8,
                  color: "var(--neutral-800, #262626)",
                  fontSize: 20,
                  fontWeight: "700",
                  lineHeight: "28px",
                }}
              >
                <div>추천 루틴 제안</div>
              </div>
              <ContentsBox>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 16 }}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <IconRT01 />
                      <p>식단</p>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        color: "var(--neutral-700#404040)",
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "20px",
                        marginTop: 4,
                      }}
                    >
                      점심 식사를{" "}
                      <span
                        style={{
                          color: "#F57C00",
                          fontSize: 14,
                          fontWeight: "700",
                          lineHeight: "20px",
                        }}
                      >
                        매일 같은 시간에 기록
                      </span>
                      해보세요. <br />
                      식사 기록이 정해진 시간에 반복되면 루틴으로 자리잡기
                      쉬워집니다.
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <IconRT02 />
                      <p>걷기</p>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        color: "var(--neutral-700#404040)",
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "20px",
                        marginTop: 4,
                      }}
                    >
                      출퇴근 시 엘리베이터 대신 계단을 한 층만 이용해보거나,{" "}
                      <span
                        style={{
                          color: "#F57C00",
                          fontSize: 14,
                          fontWeight: "700",
                          lineHeight: "20px",
                        }}
                      >
                        점심시간 10분 걷기를 루틴
                      </span>
                      처럼 반복해보세요.
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <IconRT03 />
                      <p>복약</p>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        color: "var(--neutral-700#404040)",
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "20px",
                        marginTop: 4,
                      }}
                    >
                      복약 시간을{" "}
                      <span
                        style={{
                          color: "#F57C00",
                          fontSize: 14,
                          fontWeight: "700",
                          lineHeight: "20px",
                        }}
                      >
                        식사 후, TV 보기 전 처럼 반복되는 행동
                      </span>
                      에 붙여보세요. 생활의 리듬과 함께하면 실천이 쉬워집니다.
                    </div>
                  </div>
                </div>
              </ContentsBox>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    textAlign: "center",
                  }}
                >
                  ※ 본 식단 리포트의 분석 기준은 질병관리청
                  <br /> 「2023 국민건강통계」 자료를 참고하였습니다. <br />
                  출처 : [질병관리청]{" "}
                  <a
                    href="https://knhanes.kdca.go.kr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#404040",
                      textDecoration: "underline",
                    }}
                  >
                    https://knhanes.kdca.go.kr/
                  </a>{" "}
                  <br />
                  <br />
                  ※ 본 리포트는 일반적인 건강관리 참고용으로 제공되며, <br />{" "}
                  의학적 진단이나 처방을 대체하지 않습니다. <br />
                  식습관 개선이나 건강 문제에 대해서는 <br />
                  전문가의 상담을 권장합니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </PageContainer>
  );
};
